$(document).ready(function() {




    const custom = {
        
        productSizeOnChangeValue(){
            $('.swatches__container').each(function(){
                $(this).first().find('.swatch-element .swatches__form--input:first').prop('checked', true);
                let elemFirst = $('.swatch-element .swatches__form--input').data('value');
                $(".descTam").text(elemFirst);
                $(this).find('.swatch-element input[name="id"]').on('click', function(){
                    if($(this).is(':checked')){ 
                        var txtValue = $(this).attr('data-value');
                        $(this).closest('.swatches__container').find('.swatches__option-name .descTam').text(txtValue)
                    }
                })
            })
        },

        showSecondImgOnHover() {
            $(".grid-view-item__link").each(function() {
                $(this).hover(function() {
                    $(this).parent().find(".grid-view-item__image-wrapper .hoverimg").show()
                    }, function() {
                    $(this).parent().find(".grid-view-item__image-wrapper .hoverimg").hide()
                    }
                );
            });
            $(".page-width.list-view-items .list-view-item").each(function() {
                $(this).find(".full-width-link").hover(function() {
                    $(this).parent().find(".list-view-item__link .hoverimgsearch").show()
                    }, function() {
                    $(this).parent().find(".list-view-item__link .hoverimgsearch").hide()
                    }
                );
            });
        },

        validaDeSoldout() { 
            $('.swatches_box_custom .swatches__container').each(function(index, item){

                $('#AddToCartForm').find('#addToCart').attr('value', 'Adicionar ao carrinho').prop('disabled', false);

                $(this).find('.swatch-element').on('click', function(){
                    if($(this).hasClass('soldout')){
                        $('#AddToCartForm').find('#addToCart').attr('value', 'Esgotado').prop('disabled', true);
                        $('#AddToCartForm').find('.new_custom_avisa-me').css('display','block');
                    }else{
                        $('#AddToCartForm').find('#addToCart').attr('value', 'Adicionar ao carrinho').prop('disabled', false);
                        $('#AddToCartForm').find('.new_custom_avisa-me').css('display','none');
                    }
                }) 
            });
        },

        hideTitleIfProductCustom(){
            if($('.product-template__container .swatches_box_custom').length > 0){
                
                $('.product-template__container').find('.product-single__title').hide();
                $('.product-template__container').find('.product__price').hide();
                $('.product-template__container').find('.swatches__option-name').hide();
            }
        },

        hidewishlistButton(){
            $(".swym-wishlist-button-bar").hide();
        },

        bundleProductsBuy() {

            $(".select-product.sutia").on('change', function() {
                if ( !$('.select-product.sutia').checked && !$(this).parents("form").find(".swatches__form--input").checked ) {    // both not checked
                    $(this).parents("form").find("input[name=id]").eq(0).click();
                    $(this).parents("form").find("input[name=id]").eq(0).next().addClass("highlight");
                    console.log( "produto selecionado");
                } 
                if ( !$('.select-product.sutia').is(':checked') ) {  // if product not checked
                    $(".swatches__container-0 .swatches__form--input").not(this).next().removeClass("highlight");
                }
            });

            $(".select-product.calcinha").on('change', function() {
                if ( !$('.select-product.calcinha').checked && !$(this).parents("form").find(".swatches__form--input").checked ) {    // both not checked
                    $(this).parents("form").find("input[name=id]").eq(0).click();
                    $(this).parents("form").find("input[name=id]").eq(0).next().addClass("highlight");
                    console.log( "produto selecionado");
                } 
                if ( !$('.select-product.calcinha').is(':checked') ) {  // if product not checked
                    $(".swatches__container-1 .swatches__form--input").not(this).next().removeClass("highlight");
                }
            });

            $(".form-show-sizes").each(function() {
                if( $(this).find(".calcinha-img").length == 0 ) {
                    $(".buy-from-collections").hide();
                    $(".buy-from-collections").css("display","none")
                } else {
                    $(".buy-from-collections").show();
                    $(".buy-from-collections").css("display","block")
                }
            });


            // botao de compra produtos agrupados:
            $(".buy-from-product-page").click(function(data) {


                var itemsBundleAdd = [];

                $(".swatches__container #AddToCartForm").each(function() {

                    if( !$(".select-product").is(':checked') ) {
                        alert("Selecione um tamanho, por favor").one();
                    };

                    if( $(this).find(".select-product").is(':checked') ) {   // produto checked

                        if( $(this).find("input[name=id]:checked").length > 0 ) {  // tamanho checked
                            itemsBundleAdd.push({
                                quantity: 1,
                                id: $(this).find("input[name=id]:checked").val()
                            });

                            if(itemsBundleAdd.length > 0) {  // se tem produto added no array, roda ajax
                                $.ajax({
                                    url: '/cart/add.js',
                                    type:'POST',
                                    dataType: 'json',
                                    data: {items: itemsBundleAdd},
                                    success: function(response){
                                        console.log('Response -> ', response);
                                        window.location.replace("/cart");
                                    },
                                    error: function(error){
                                        console.log('ERROR', error);
                                        alert("Tente novamente mais tarde!")
                                    }
                                })
                            } else {
                                console.log("itemsBundleAdd.length menor que 0")
                            }

                        } else {                                     // tamanho not checked
                            console.log("tamanho nao checado")
                        }
                    } 
                });

                
            });
        },

        selectCheckboxProducts() {
            setTimeout(function(){   
                // uncheck all sizes in Product Page
                $('.swatches__container-0 .swatches__form--input').prop('checked', false);
                $('.swatches__container-1 .swatches__form--input').prop('checked', false);
                // Select first sizes:
                $('.swatches__container-0 .swatches__form--input:first').prop('checked', true);
                $('.swatches__container-0 .swatches__form--input:first').next().addClass("highlight");
                $('.swatches__container-1 .swatches__form--input:first').prop('checked', true);
                $('.swatches__container-1 .swatches__form--input:first').next().addClass("highlight");
            }, 1000);
            /////////////////////////////////////////////////////////////////////////////////

            // Turn checkboxes(INDEX0) into input radio (only one product selected):
            $(".swatches__container-0 .swatches__form--input").on('change', function() {
                $(this).next().addClass("highlight");
                $('.select-product.sutia').prop('checked', true);
                $(".swatches__container-0 .swatches__form--input").not(this).prop('checked', false);  
                $(".swatches__container-0 .swatches__form--input").not(this).next().removeClass("highlight");
        
                if (!$('.swatches__container-0 .swatches__form--input:checked').length ) {  // if no checkbox selected, remove highlight
                    $(".swatches__container-0 .swatches__form--input").next().removeClass("highlight");
                    $('.select-product.sutia').prop('checked', false);
                }
            });

            // click on label triggers 'click' on hidden checkbox
            $(".swatches__container-0 .swatches__form--label").click(function(){  
                $(this).prev().trigger('click');
            });
            /////////////////////////////////////////////////////////////////////////////////


            // Turn checkboxes(INDEX1) into input radio (only one product selected):
            $(".swatches__container-1 .swatches__form--input").on('change', function() {
                $(this).next().addClass("highlight");
                $('.select-product.calcinha').prop('checked', true);
                $(".swatches__container-1 .swatches__form--input").not(this).prop('checked', false);  
                $(".swatches__container-1 .swatches__form--input").not(this).next().removeClass("highlight");
        
                if (!$('.swatches__container-1 .swatches__form--input:checked').length ) {  // if no checkbox selected, remove highlight
                    $(".swatches__container-1 .swatches__form--input").next().removeClass("highlight");
                    $('.select-product.calcinha').prop('checked', false);
                }
            });

            // click on label triggers 'click' on hidden checkbox
            $(".swatches__container-1 .swatches__form--label").click(function(){  
                $(this).prev().trigger('click');
            });
            /////////////////////////////////////////////////////////////////////////////////
        }

    }

    $(function(){
        custom.productSizeOnChangeValue();
        custom.showSecondImgOnHover();
        custom.validaDeSoldout();
        custom.hideTitleIfProductCustom(); 
        setTimeout(function () {
            custom.hidewishlistButton();
        }, 200);
        custom.bundleProductsBuy();
        custom.selectCheckboxProducts();
    });

});